// src/components/BottomNav.jsx
import React from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import {Calendar, ClipboardList, Grid3X3, Home as HomeIcon, User} from 'lucide-react';
import {getManagerName, isLoggedIn} from '../utils/auth';

export default function BottomNav() {
    const navigate = useNavigate();
    const location = useLocation();

    const tabs = [
        {icon: HomeIcon, label: 'Главная', path: '/'},
        {icon: Calendar, label: 'Месяц', path: '/month'},
        {icon: Grid3X3, label: 'Неделя', path: '/week'},
        {icon: ClipboardList, label: 'Регистр', path: '/reserv'},
        {icon: User, label: isLoggedIn() ? getManagerName().split(' ')[0] : 'Войти', path: '/auth'},
    ];

    const handleClick = (path) => {
        if (!isLoggedIn() && path !== '/' && path !== '/auth') {
            navigate('/auth');
            return;
        }
        navigate(path);
    };

    const isActive = (path) => location.pathname === path || (path === '/' && location.pathname === '/home');

    return (
        <div className="app-bottom-nav fixed inset-x-0 bottom-0 bg-white border-t border-gray-200 z-50 shadow-2xl">
            <div className="flex">
                {tabs.map(({icon: Icon, label, path}) => (
                    <button
                        key={path}
                        onClick={() => handleClick(path)}
                        className={`flex-1 h-20 flex flex-col items-center justify-center gap-1 transition-all ${
                            isActive(path) ? 'text-blue-600' : 'text-gray-500'
                        }`}
                    >
                        <Icon size={26} strokeWidth={isActive(path) ? 2.8 : 2}/>
                        <span className="text-xs font-medium">{label}</span>
                    </button>
                ))}
            </div>
        </div>
    );
}
